import type { ProviderOperationsBulkPlan } from "./getProviderOperationsBulkPlan";

export enum ProviderOperationsBulkRowOutcome {
	SUCCEEDED = "succeeded",
	FAILED = "failed",
	SKIPPED = "skipped",
}

export type ProviderOperationsBulkSummary = {
	succeededCount: number;
	failedCount: number;
	/** Rows skipped before sending plus requests the backend no longer found eligible. */
	skippedCount: number;
};

export function getProviderOperationsBulkSummary(
	plan: ProviderOperationsBulkPlan,
	rowOutcomes: ProviderOperationsBulkRowOutcome[],
): ProviderOperationsBulkSummary {
	const countOutcome = (outcome: ProviderOperationsBulkRowOutcome) =>
		rowOutcomes.filter((rowOutcome) => rowOutcome === outcome).length;

	return {
		succeededCount: countOutcome(ProviderOperationsBulkRowOutcome.SUCCEEDED),
		failedCount: countOutcome(ProviderOperationsBulkRowOutcome.FAILED),
		skippedCount: plan.skippedCount + countOutcome(ProviderOperationsBulkRowOutcome.SKIPPED),
	};
}
